import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { STATION_WARNING_SOURCES } from '../station-warning-map/station-warning-map-constants';

@Component({
  selector: 'app-station-warning-sidebar',
  templateUrl: './station-warning-sidebar.component.html',
  styleUrls: ['./station-warning-sidebar.component.scss']
})
export class StationWarningSidebarComponent implements OnInit {
  sourceOptions: any;
  queryParams: any;
  isInitialLoad: boolean = false;
  selected: string;
  selectedSource: any;

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }
  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        // this.dateIndexLength = 12
        this.sourceOptions = STATION_WARNING_SOURCES['sourceList']
        this.selectedSource = 'Mausam IMD'
        this.requestSelectedFilterParams()
      }
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'STATIONWARNINGS';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

}
